import {useContext, useId} from 'react';
import {useListItem} from '@floating-ui/react';
import type {FloatingMenuContextType} from '../floating-menu-context';
import {FloatingMenuContext} from '../floating-menu-context';

export type UseFloatingMenuItemReturn = FloatingMenuContextType & {
    ref: (node: HTMLElement | null) => void,
    index: number,
    id: string,
    tabIndex: number,
    highlighted: boolean,
};

/**
 * Hook for floating menu item.
 * Connects menu item with floating menu context.
 */
export const useFloatingMenuItem = (): UseFloatingMenuItemReturn => {
    const id = useId(); // for virtual focus management
    const {ref, index} = useListItem();
    const {activeIndex, ...rest} = useContext(FloatingMenuContext);
    const highlighted = activeIndex === index;

    return {
        ref,
        index,
        activeIndex,
        highlighted,
        id,
        tabIndex: highlighted ? 0 : -1,
        ...rest,
    };
};
